import { createApiCall } from 'lib/base';
import { generateEndpoint } from '@ngtrvu/use-api';

const FETCH_INVESTCORE_EMPLOYEE_PROGRAMS_API_ID =
  'DASHBOARD/FETCH_INVESTCORE_EMPLOYEE_PROGRAMS_API_ID';

const apiCall = createApiCall(
  FETCH_INVESTCORE_EMPLOYEE_PROGRAMS_API_ID,
  params => ({
    endpoint: generateEndpoint({
      host: `/api/admin/employee-programs`,
      params,
    }),
    method: 'GET',
  })
);

export default apiCall;
